// extracted by mini-css-extract-plugin
export var icon = "icon-module--icon--pfyxW";
export var label = "icon-module--label--0kTmI";
export var root = "icon-module--root--w5ys5";